




























import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class Burger extends Vue {
  @Prop({ default: [] }) links!: { title: string; route: string }[];
  private burgerActive = false;

  toggle() {
    this.burgerActive = !this.burgerActive;
  }
}
